import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';
import { useState } from 'react';
import { useAsyncRetry } from 'react-use';
import PlatformUserTermSearch from './api';
import { ManagePlatformUserTerm, TCriteriaPlatformUserTermItem } from './type';

export type TUsePlatformUserTermSearch = {
  isLoading: boolean;
  response: ManagePlatformUserTerm;
  criteria?: TCriteriaPlatformUserTermItem;
  handleOnChangeCriteria: (newCriteria: TCriteriaPlatformUserTermItem) => void;
  handleResetState: () => void;
  onRetry: () => void;
};

const usePlatformUserTermSearch = (): TUsePlatformUserTermSearch => {
  const [criteria, setCriteria] = useState<TCriteriaPlatformUserTermItem>();
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const stateAsyncRetry = useAsyncRetry(async () => {
    const response: Promise<ManagePlatformUserTerm> = await commonActionFromDALV2(PlatformUserTermSearch, criteria);
    const result = await response;
    return result;
  }, [criteria]);

  const handleResetState = () => setCriteria(undefined);

  const handleOnChangeCriteria = (newCriteria: TCriteriaPlatformUserTermItem) => {
    setCriteria((prev: TCriteriaPlatformUserTermItem) => {
      return { ...prev, ...newCriteria };
    });
  };

  return {
    criteria,
    handleResetState,
    handleOnChangeCriteria,
    response: stateAsyncRetry?.value || new ManagePlatformUserTerm(),
    isLoading: stateAsyncRetry.loading,
    onRetry: stateAsyncRetry?.retry,
  };
};

export default usePlatformUserTermSearch;
